module.exports = __webpack_public_path__ + "static/media/insife.77ff8ec4.jpg";